import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=43527b6a&"
import script from "./ViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ViewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports